// Configuration file for the application

// API URL - Change this to your actual API endpoint
export const API_URL = 'https://desol-ai-backend.desol.workers.dev';

// Solana network configuration
export const SOLANA_NETWORK = 'mainnet-beta';
export const SOLANA_RPC_URL = 'https://api.mainnet-beta.solana.com';

// Application settings
export const APP_NAME = 'Desol AI';
export const APP_VERSION = '0.1.0';

// Feature flags
export const FEATURES = {
  AI_ENABLED: true,
  GOVERNANCE_ENABLED: true,
  REWARDS_ENABLED: true,
  EXPLORER_ENABLED: true
};

// Cloudflare Pages config
export const CF_PAGES_URL = 'https://desol-frontend.pages.dev';

// Theme colors - matches the UI in the image
export const THEME_COLORS = {
  background: '#1a1a2e',
  cardBackground: '#24243e',
  accent: '#7678ed',
  text: '#ffffff',
  secondaryText: '#a9a9c8',
  success: '#00ff9d',
  warning: '#ffcc00',
  error: '#ff0066',
  voting: {
    yes: '#00ff9d',
    no: '#ff0066'
  }
};